export default __webpack_public_path__ + "static/media/cosmopolitan-funeral-min.3e2aaf8a.png";